module.exports = "/_next/static/images/contact-acf6b4bf363513df4dc936e89bb5b86d.svg";